import { BetaFlags } from '@showbie-socrative/socrative-utils';
import { ApplicationState } from 'clients/app/src/rootReducer';

const selectTeacherId = (state: ApplicationState) =>
  state.teachers.teacher.teacherId;

const selectCurrentRoomId = (state: ApplicationState) =>
  state.teachers.teacher.currentRoomId;

const selectIsPaywallOpen = (state: ApplicationState) =>
  state.teachers.teacher.isPaywallOpen;

const selectPaywallTouch = (state: ApplicationState) =>
  state.teachers.teacher.paywallTouch;

const selectIsRequestInProgress = (state: ApplicationState) =>
  state.teachers.teacher.isRequestInProgress;

const selectQuizBetaVersion = (state: ApplicationState) => {
  const betaFlags = state.teachers.teacher.betaFlags as BetaFlags;

  if (betaFlags && betaFlags.quiz_editor_version) {
    return betaFlags.quiz_editor_version;
  } else {
    return null;
  }
};

const selectBetaFlags = (state: ApplicationState) =>
  state.teachers.teacher.betaFlags as BetaFlags;

const selectCurrentRoomActivity = (state: ApplicationState) =>
  state.teachers.teacher.currentRoomActivity;

const selectCurrentRoomIsShowbie = (state: ApplicationState) =>
  state.teachers.teacher.isCurrentRoomShowbie;

export {
  selectTeacherId,
  selectCurrentRoomId,
  selectIsPaywallOpen,
  selectPaywallTouch,
  selectIsRequestInProgress,
  selectQuizBetaVersion,
  selectBetaFlags,
  selectCurrentRoomActivity,
  selectCurrentRoomIsShowbie,
};
